export default __webpack_public_path__ + "static/media/my_projects.57214bda.svg";